// import React, { useState, useRef, useEffect } from "react";
// import "./header.css";
// import { toggleIcon } from "../../assets/ExportImageIcon";
// import CommonModal from "../modals/CommonModal";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { logout } from "../../redux/auth/authSlice";
// import service from "../../services/service";
// import endpoints from "../../services/endpoints";
// import { showToast } from "../../utils/toast";

// // user_type: 0 = Super Admin, 1 = Admin, 3 = Consultant/Manager
// const getRoleName = (role) => {
//   if (role === 3) return "Consultant";
//   if (role === 0) return "Super Admin";
//   if (role === 1) return "Admin";
//   return "Super Admin";
// };

// const getInitials = (email) => {
//   if (!email) return "?";
//   return email.slice(0, 2).toUpperCase();
// };

// const Header = ({ onToggle }) => {
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [showSignOutModal, setShowSignOutModal] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const dropdownRef = useRef(null);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const refresh_token = useSelector((state) => state.auth.refresh_token);
//   const user = useSelector((state) => state.auth.user);
//   const role = useSelector((state) => state.auth.role);

//   const userData = {
//     name: getRoleName(role),
//     email: user?.email || "",
//     profile: user?.profile ?? null,
//     initials: getInitials(user?.email),
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setShowDropdown(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const handleSettingsClick = () => {
//     setShowDropdown(false);
//     navigate(role === 3 ? "/manager-profile" : "/settings");
//   };

//   const handleSignOut = () => {
//     setShowDropdown(false);
//     setShowSignOutModal(true);
//   };

//   const confirmSignOut = async () => {
//     setLoading(true);
//     try {
//       const res = await service.post(
//         endpoints.auth.logout,
//         { refresh_token },
//         { skipToast: true },
//       );
//       showToast(res.data.message, "success");
//       dispatch(logout());
//       navigate("/", { replace: true });
//       setShowSignOutModal(false);
//     } catch (error) {
//       const message =
//         error.response?.data?.message || "Failed to logout. Please try again.";
//       showToast(message, "error");
//       setShowSignOutModal(false);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <header className="top-header">
//         <div className="header-left">
//           <button className="hamburger-btn" onClick={onToggle}>
//             <img src={toggleIcon} alt="toggle" />
//           </button>

//           {/* <div className="search-wrapper">
//             <input type="text" placeholder="Search..." />
//           </div> */}
//         </div>

//         <div className="header-right">
//           <button className="notification-btn"></button>

//           <div className="profile-dropdown-wrapper" ref={dropdownRef}>
//             <div
//               className="profile-trigger"
//               onClick={() => setShowDropdown(!showDropdown)}
//             >
//               <div className="profile-info">
//                 <span className="profile-name">{userData.name}</span>
//                 <span className="profile-email">{userData.email}</span>
//               </div>
//               <div className="profile-avatar">
//                 {userData.profile ? (
//                   <img src={userData.profile} alt="profile" />
//                 ) : (
//                   userData.initials
//                 )}
//               </div>
//             </div>

//             {showDropdown && (
//               <div className="profile-dropdown">
//                 <div className="dropdown-header">
//                   <span className="dropdown-label">Logged in as</span>
//                   <span className="dropdown-email">{userData.email}</span>
//                 </div>
//                 <div className="dropdown-divider"></div>
//                 <button className="dropdown-item" onClick={handleSettingsClick}>
//                   Settings
//                 </button>
//                 <button className="dropdown-item" onClick={handleSignOut}>
//                   Sign Out
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       </header>

//       <CommonModal
//         isOpen={showSignOutModal}
//         onClose={() => !loading && setShowSignOutModal(false)}
//         title="Sign Out"
//         message="Are you sure you want to sign out ?"
//         onConfirm={confirmSignOut}
//         onCancel={() => !loading && setShowSignOutModal(false)}
//         confirmText={loading ? "Signing out..." : "Sign Out"}
//         cancelText="Cancel"
//       />
//     </>
//   );
// };

// export default Header;



import React, { useState, useRef, useEffect } from "react";
import "./header.css";
import { toggleIcon } from "../../assets/ExportImageIcon";
import CommonModal from "../modals/CommonModal";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../redux/auth/authSlice";
import service from "../../services/service";
import endpoints from "../../services/endpoints";
import { showToast } from "../../utils/toast";

// user_type: 0 = Super Admin, 1 = Admin, 3 = Consultant/Manager
const getRoleName = (role) => {
  if (role === 3) return "Consultant";
  if (role === 0) return "Super Admin";
  if (role === 1) return "Admin";
  return "Super Admin";
};

const getInitials = (email) => {
  if (!email) return "?";
  return email.slice(0, 2).toUpperCase();
};

// Get user's timezone
const getUserTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (error) {
    return "UTC";
  }
};

// Format current time in user's timezone
const getCurrentTimeInTimezone = (timezone) => {
  try {
    return new Date().toLocaleTimeString('en-US', {
      timeZone: timezone,
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  } catch (error) {
    return new Date().toLocaleTimeString();
  }
};

const Header = ({ onToggle }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [showSignOutModal, setShowSignOutModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentTime, setCurrentTime] = useState("");
  const dropdownRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const refresh_token = useSelector((state) => state.auth.refresh_token);
  const user = useSelector((state) => state.auth.user);
  const role = useSelector((state) => state.auth.role);

  const userTimezone = getUserTimezone();
  const userData = {
    name: getRoleName(role),
    email: user?.email || "",
    profile: user?.profile ?? null,
    initials: getInitials(user?.email),
    timezone: userTimezone,
  };

  // Update current time every minute
  useEffect(() => {
    const updateTime = () => {
      setCurrentTime(getCurrentTimeInTimezone(userTimezone));
    };
    updateTime();
    const interval = setInterval(updateTime, 60000); // Update every minute
    return () => clearInterval(interval);
  }, [userTimezone]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSettingsClick = () => {
    setShowDropdown(false);
    navigate(role === 3 ? "/manager-profile" : "/settings");
  };

  const handleSignOut = () => {
    setShowDropdown(false);
    setShowSignOutModal(true);
  };

  const confirmSignOut = async () => {
    setLoading(true);
    try {
      const res = await service.post(
        endpoints.auth.logout,
        { refresh_token },
        { skipToast: true },
      );
      showToast(res.data.message, "success");
      dispatch(logout());
      navigate("/", { replace: true });
      setShowSignOutModal(false);
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to logout. Please try again.";
      showToast(message, "error");
      setShowSignOutModal(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <header className="top-header">
        <div className="header-left">
          <button className="hamburger-btn" onClick={onToggle}>
            <img src={toggleIcon} alt="toggle" />
          </button>

          {/* <div className="search-wrapper">
            <input type="text" placeholder="Search..." />
          </div> */}
        </div>

        <div className="header-right">
          {/* Timezone Display - Optional */}
          <div className="timezone-display" style={{ marginRight: "16px", fontSize: "12px", color: "#6B7280" }}>
            <span>{userTimezone} • {currentTime}</span>
          </div>

          <button className="notification-btn"></button>

          <div className="profile-dropdown-wrapper" ref={dropdownRef}>
            <div
              className="profile-trigger"
              onClick={() => setShowDropdown(!showDropdown)}
            >
              <div className="profile-info">
                <span className="profile-name">{userData.name}</span>
                <span className="profile-email">{userData.email}</span>
              </div>
              <div className="profile-avatar">
                {userData.profile ? (
                  <img src={userData.profile} alt="profile" />
                ) : (
                  userData.initials
                )}
              </div>
            </div>

            {showDropdown && (
              <div className="profile-dropdown">
                <div className="dropdown-header">
                  <span className="dropdown-label">Logged in as</span>
                  <span className="dropdown-email">{userData.email}</span>
                </div>
                <div className="dropdown-divider"></div>
                {/* Show timezone in dropdown */}
                <div className="dropdown-timezone" style={{ padding: "8px 16px", fontSize: "12px", color: "#6B7280", borderBottom: "1px solid #E5E7EB" }}>
                  <span>Timezone: {userData.timezone}</span>
                  <span style={{ marginLeft: "8px" }}>•</span>
                  <span style={{ marginLeft: "8px" }}>{currentTime}</span>
                </div>
                <button className="dropdown-item" onClick={handleSettingsClick}>
                  Settings
                </button>
                <button className="dropdown-item" onClick={handleSignOut}>
                  Sign Out
                </button>
              </div>
            )}
          </div>
        </div>
      </header>

      <CommonModal
        isOpen={showSignOutModal}
        onClose={() => !loading && setShowSignOutModal(false)}
        title="Sign Out"
        message="Are you sure you want to sign out ?"
        onConfirm={confirmSignOut}
        onCancel={() => !loading && setShowSignOutModal(false)}
        confirmText={loading ? "Signing out..." : "Sign Out"}
        cancelText="Cancel"
      />
    </>
  );
};

export default Header;